import vClickOutside from "v-click-outside";

export default {
	directives: { clickOutside: vClickOutside.directive },

	props: {
		placeholder: {
			type: String,
			required: true,
		},
		items: {
			// {label: string}
			type: Array,
		},
	},

	data() {
		return {
			isOpen: false,
			// {label: string}
			selectedItem: null,
		};
	},

	methods: {
		close,
		select,
	},
};

function close() {
	this.isOpen = false;
}

function select(item) {
	this.selectedItem = item;
	this.$emit("select", item);
}
